(function () {
  function fitQuote(quote) {
    var target = parseFloat(window.getComputedStyle(quote).maxHeight);
    if (!target || isNaN(target)) target = 132;

    quote.style.fontSize = '';
    quote.style.maxHeight = 'none';
    quote.style.overflow = 'visible';

    var min = 10;
    var size = parseFloat(window.getComputedStyle(quote).fontSize) || 16;
    var guard = 0;
    while (quote.scrollHeight > target && size > min && guard < 120) {
      size -= 0.5;
      quote.style.fontSize = size + 'px';
      guard += 1;
    }

    quote.style.maxHeight = target + 'px';
    quote.style.overflow = 'hidden';
  }

  function fitQuotesIn(el) {
    if (!el) return;
    el.querySelectorAll('.reviews__quote').forEach(fitQuote);
  }

  function fitQuotes(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.reviews__quote').forEach(fitQuote);
  }

  function positionNavigation(carousel) {
    if (!carousel) return;
    var wrapper = carousel.closest('.reviews__carousel-wrapper');
    var media = carousel.querySelector('.reviews__media');
    if (!wrapper || !media) return;

    var top = media.offsetTop + media.offsetHeight / 2;
    wrapper.style.setProperty('--reviews-nav-top', top + 'px');
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.swiper) return;

    var wrapper = carousel.closest('.reviews__carousel-wrapper') || carousel.parentNode;
    var nextEl = wrapper.querySelector('[data-reviews-next]');
    var prevEl = wrapper.querySelector('[data-reviews-prev]');

    var refit = function (sw) {
      requestAnimationFrame(function () {
        fitQuotesIn(sw.el);
        positionNavigation(sw.el);
      });
    };

    new Swiper(carousel, {
      slidesPerView: 2,
      spaceBetween: 12,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      breakpoints: {
        720: {
          slidesPerView: 3.25,
          spaceBetween: 24,
        },
      },
      on: {
        afterInit: refit,
        resize: refit,
        breakpoint: refit,
      },
    });
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-reviews-carousel]').forEach(initCarousel);
    setTimeout(function () {
      fitQuotes(scope);
    }, 300);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fitQuotes(scope);
      });
    }
  }

  function whenSwiperReady(callback) {
    if (window.Swiper) {
      callback();
      return;
    }
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if (window.Swiper) {
        clearInterval(timer);
        callback();
      } else if (attempts > 100) {
        clearInterval(timer);
      }
    }, 100);
  }

  function boot() {
    whenSwiperReady(function () {
      initAll(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    whenSwiperReady(function () {
      initAll(event.target);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var carousel = event.target.querySelector('[data-reviews-carousel]');
    if (carousel && carousel.swiper) {
      carousel.swiper.destroy(true, true);
    }
  });
})();
